import PromotionItem from "./promotion-item";

export default PromotionItem;